"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calendarCancel = exports.iconName = exports.paths = void 0;
exports.paths = [{ "tag": "path", "att": { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M10 4v2h4V4h2v2h4v7H6v5h7v2H4V6h4V4h2zm4 4v2h2V8h2v3H6V8h2v2h2V8h4z" } }, { "tag": "path", "att": { "d": "m20.5856 21.9996-2.121-2.121L16.3431 22l-1.4142-1.4142 2.1215-2.1214-2.1216-2.1216 1.4142-1.4142 2.1216 2.1215 2.1212-2.1212L22 16.3431l-2.1212 2.1213 2.121 2.121-1.4142 1.4142z" } }];
exports.iconName = 'calendar-cancel';
exports.calendarCancel = { iconName: exports.iconName, paths: exports.paths };
exports.default = exports.paths;
